import { useState } from 'react';
import { Box, Grid } from '@mui/material';
import './date-month-year.scss';
import { MobileDatePicker, LocalizationProvider} from '@mui/x-date-pickers';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Stack from '@mui/material/Stack';
import es from 'date-fns/locale/es';

export const DatePickerMonthYear = ({dateData, onAction}: any) => {
    const [value, setValue] = useState<Date>(dateData.valueDate);
    
    return (
        <Box className="box-datepicker">
            <Grid container justifyContent={'center'}>
                <Grid item xs={12}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                        <Stack spacing={3}>
                            <MobileDatePicker
                                    views={['year', 'month']}
                                    label={dateData.labelText || 'Mes y año'}
                                    minDate={dateData.minDate}
                                    maxDate={dateData.maxDate}
                                    value={value}
                                    onChange={(newValue: Date | null) => {
                                        if (newValue) setValue(newValue);
                                    }}
                                    onAccept={(newValue: Date | null) => {
                                        if (newValue) {
                                            setValue(newValue);
                                            onAction(newValue);
                                        }
                                    }}
                                    slots={{ textField: TextField }}
                                    slotProps={{
                                        textField: { helperText: null },
                                    }}
                            />
                        </Stack>
                    </LocalizationProvider>
                </Grid>
            </Grid>
        </Box>
    )
}